<list-flat *ngIf="productIds.length > 0" [svg]="true" [lined]="true">
    <ng-container *ngFor="let productId of productIds">
        <ng-container [ngSwitch]="productId">
            <li *ngSwitchCase="productIdEnum.Car">
                <ins-pdf-link [pdfLink]="documentsEnum.ConditionsCarInsurance" pdfLinkClass="link-flat link-flat--icon"
                              pdfLinkTitle="Voorwaarden Autoverzekering">
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#auto"></use>
                    </svg>
                    Autoverzekering
                </ins-pdf-link>
            </li>


            <li *ngSwitchCase="productIdEnum.Moped">
                <ins-pdf-link
                    [pdfLink]="documentsEnum.ConditionsMopedInsurance"
                    pdfLinkClass="link-flat link-flat--icon"
                    pdfLinkTitle="Voorwaarden Brommerverzekering"
                >
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#brommer"></use>
                    </svg>
                    Brommerverzekering
                </ins-pdf-link>
            </li>

            <li *ngSwitchCase="productIdEnum.Home">
                <ins-pdf-link
                    [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                    pdfLinkClass="link-flat link-flat--icon"
                    pdfLinkTitle="Voorwaarden Woonverzekering"
                >
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#huis"></use>
                    </svg>
                    Woonverzekering
                </ins-pdf-link>
            </li>

            <li *ngSwitchCase="productIdEnum.Liability">
                <ins-pdf-link
                    [pdfLink]="documentsEnum.ConditionsLiabilityInsurance"
                    pdfLinkClass="link-flat link-flat--icon"
                    pdfLinkTitle="Voorwaarden Aansprakelijkheidsverzekering"
                >
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#recht"></use>
                    </svg>
                    Aansprakelijkheidsverzekering
                </ins-pdf-link>
            </li>

            <li *ngSwitchCase="productIdEnum.Travel">
                <ins-pdf-link
                    [pdfLink]="documentsEnum.ConditionsTravelInsurance"
                    pdfLinkClass="link-flat link-flat--icon"
                    pdfLinkTitle="Voorwaarden Reisverzekering"
                >
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#vakantie"></use>
                    </svg>
                    Reisverzekering
                </ins-pdf-link>
            </li>

            <li *ngSwitchCase="productIdEnum.LegalAssistance">
                <ins-pdf-link
                    [pdfLink]="documentsEnum.ConditionsLegalInsurance"
                    pdfLinkClass="link-flat link-flat--icon"
                    pdfLinkTitle="Voorwaarden Rechtsbijstandverzekering"
                >
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#legal"></use>
                    </svg>
                    Rechtsbijstandverzekering
                </ins-pdf-link>
            </li>

            <li *ngSwitchCase="productIdEnum.Accidents">
                <ins-pdf-link
                    [pdfLink]="documentsEnum.ConditionsAccidentInsurance"
                    pdfLinkClass="link-flat link-flat--icon"
                    pdfLinkTitle="Voorwaarden Ongevallenverzekering"
                >
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#letsel"></use>
                    </svg>
                    Ongevallenverzekering
                </ins-pdf-link>
            </li>

            <li *ngSwitchCase="productIdEnum.Caravan">
                <ins-pdf-link
                    [pdfLink]="documentsEnum.ConditionsCaravanInsurance"
                    pdfLinkClass="link-flat link-flat--icon"
                    pdfLinkTitle="Voorwaarden Caravanverzekering"
                >
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#caravan"></use>
                    </svg>
                    Caravanverzekering
                </ins-pdf-link>
            </li>

            <li *ngSwitchCase="productIdEnum.Pet">
                <ins-pdf-link
                    [pdfLink]="documentsEnum.ConditionsPetInsurance"
                    pdfLinkClass="link-flat link-flat--icon"
                    pdfLinkTitle="Voorwaarden Dierenverzekering"
                >
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#dieren"></use>
                    </svg>
                    Dierenverzekering
                </ins-pdf-link>
            </li>

            <li *ngSwitchCase="productIdEnum.Motorcycle">
                <ins-pdf-link
                    [pdfLink]="documentsEnum.ConditionsMotorInsurance"
                    pdfLinkClass="link-flat link-flat--icon"
                    pdfLinkTitle="Voorwaarden Motorverzekering"
                >
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#motor"></use>
                    </svg>
                    Motorverzekering
                </ins-pdf-link>
            </li>

            <li *ngSwitchCase="productIdEnum.Bicycle">
                <ins-pdf-link
                    [pdfLink]="documentsEnum.ConditionsBicycleInsurance"
                    pdfLinkClass="link-flat link-flat--icon"
                    pdfLinkTitle="Voorwaarden Fietsverzekering"
                >
                    <svg class="svg-icon svg-icon--s">
                        <use href="assets/icons-ui.svg#fiets"></use>
                    </svg>
                    Fietsverzekering
                </ins-pdf-link>
            </li>
        </ng-container>
    </ng-container>
</list-flat>
